module.exports = __webpack_public_path__ + "static/media/curves_avellana.f7224857.jpg";